export const editDialogConfig = {
  addMainEvn: {
    name: "addMainEvn",
    title: "新增主事件分類",
    content: "主事件分類",
  },
  addSubEvn: {
    name: "addSubEvn",
    title: "新增子事件分類",
    content: "子事件分類",
  },
  updateMainEvn: {
    name: "updateMainEvn",
    title: "重新命名",
    content: "主事件分類",
  },
  updateSubEvn: {
    name: "updateSubEvn",
    title: "重新命名",
    content: "子事件分類",
  },
  deleteEvn: {
    name: "deleteEvn",
    title: "刪除事件分類",
    content:
      "事件分類即將被刪除。請注意，若該事件包含其他事件將全部刪除，刪除後無法復原。",
  },
  deleteRow: {
    name: "deleteRow",
    title: "刪除列表",
    content: "列表內容即將被刪除。請注意，刪除後將無法復原欄列表內容。",
  },
  addNewTitle: "新增",
  deleteTitle: "刪除",
  cancelTitle: "取消",
  required: " *",
  placeholder: "請輸入事件分類",
};

export const TooltipTitle =
  "事件分類包含系統預設事件和自訂義事件，若該事件為系統預設事件則不可編緝和刪除。";
